import { useEffect } from 'react'

import { useAppDispatch } from '../context/AppContext'
import { createCompanyTheme } from '../styles/colors'

// Applies a company's brand colours to the global theme. Shared by the public
// Employer Branding pages (manifesto/home + careers) so they render in the
// company's own palette — identically to how App.tsx applies them in-platform.
const useApplyCompanyTheme = (companyColors?: {
  [key: string]: number[]
}): void => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    if (!companyColors) return
    dispatch({
      type: 'updateTheme',
      payload: createCompanyTheme(companyColors),
    })
  }, [companyColors])
}

export default useApplyCompanyTheme
